module.exports = __webpack_public_path__ + "img/Move.35ec430f.svg";